import type { WavespeedModelConfig } from '../../types';
import { qwenConfigs } from './qwen';
import { wanConfigs } from './wan';
import { zimageConfigs } from './zimage';

export const alibabaConfigs: Record<string, WavespeedModelConfig> = {
    ...qwenConfigs,
    ...wanConfigs,
    ...zimageConfigs,
};